import React from "react";

import { css } from "@emotion/react";

import cn from "classnames";
import { CSS_MQ } from "../../styles/breakpoints";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { TextType } from "@swo/storefront";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { defaultRichTextOptions } from "../../utils/contentful/rich-text-formatting";
import { FONTS } from "../../styles/fonts";
import { richTextStyles } from "../../styles/rich-text";
import { plainTextStyles } from "../../styles/text-styles";
import { SORichTextRenderer } from "../_shared-components/so-rich-text";

export function TextComponent(props: TextType) {
  return (
    <ContentContainer className={getComponentCMSClassname(props?.sys?.id)}>
      <section
        className={cn(
          props.layout === "Two columns" ? "column-double" : "column-single",
          props.layout === "Single column - align left" ? "align-left" : "align-center",
        )}
        css={richTextWrapperStyles}
      >
        <SORichTextRenderer richText={props.richText} options={defaultRichTextOptions} />
      </section>
    </ContentContainer>
  );
}

const richTextWrapperStyles = [
  FONTS.SwarovskiFutura300,
  plainTextStyles,
  richTextStyles,
  css`
    &.align-center {
      margin-left: auto;
      margin-right: auto;
    }

    &.column-single {
      width: 100%;

      ${CSS_MQ.atLeastSm} {
        width: 80%;
      }

      ${CSS_MQ.atLeastMd} {
        width: 75%;
      }

      ${CSS_MQ.atLeastLg} {
        width: 65%;
      }

      ${CSS_MQ.atLeastXl} {
        width: 50%;
      }
    }

    &.column-double {
      ${CSS_MQ.atLeastMd} {
        column-count: 2;
      }
    }
  `,
];
